export const defaultDailyNutritionState = {
  nutrition: {},
  score: {},
  statistics: { today: { statistics: {} } },
}
